import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { get } from '../../utils/Api';
import { getUserData } from '../../utils/LocalStorage';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function DocumentoDialog({
  openDocumentoDialog,
  handleCloseDocumentoDialog,
  handleAbrirCampos,
  setLoading,
  handleMessage,
}) {
  const [formData, setFormData] = useState({
    documento_nome_cliente: '',
    genero_uuid: '',
    modelo_uuid: '',
    modelo_versao: '',
    escritorio_uuid: '',
  });

  const [generos,setGeneros] = useState([]);
  const [modelos,setModelos] = useState([]);
  const [escritorios,setEscritorios] = useState([]);
  const [usuarioRoot,setUsuarioRoot] = useState(false);

  const handleChange = (event) => {
    const {name, value} = event.target;
    setFormData((dados) => ({
      ...dados,
      [name]: value,
    }));
  };

  const handleChangeModelo = (event) => {
    const value = event.target.value;
    setFormData((dados) => ({
      ...dados,
      'modelo_uuid': value,
      'modelo_versao': `v${modelos.find(modelo => modelo.modelo_uuid === value).modelo_versao}`,
    }));
  };

  const handleChangeEscritorio = (event) => {
    const value = event.target.value;
    setFormData((dados) => ({
      ...dados,
      'escritorio_uuid': value,
    }));
  };

  useEffect(()=>{
    setLoading(true);
    getUserData((administrador,root,escritorio_uuid)=>{
      setUsuarioRoot(root);

      get(`api/listas/${escritorio_uuid}`,(json)=>{

        setFormData((estadoAnterior) => ({
          ...estadoAnterior,
          escritorio_uuid: json.escritorios.find(entry => entry.escritorio_uuid === escritorio_uuid).escritorio_uuid,
        }));

        setGeneros(json.generos);
        setModelos(json.modelos.filter(entry => entry.escritorio_uuid === escritorio_uuid));
        setEscritorios(json.escritorios);

        setLoading(false);
      },(error,message,severity)=>{
        setLoading(false);
        handleMessage(message,severity,error,true);
      });
    });
  },[]);

  return (
    <Dialog
      closeAfterTransition={false}
      open={openDocumentoDialog}
      onClose={handleCloseDocumentoDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      role="alertdialog"
      component="form"
      onSubmit={(event) => {
        event.preventDefault();
        handleAbrirCampos(formData)
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
          <TextSnippetIcon sx={{ display: 'flex' }} />
          <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
            Novo Documento
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{ width: { xs: 'auto', sm: 600 } }}>

        <Grid
          container
          spacing={3}
          sx={{
            marginTop: 4,
          }}>

          <Grid item="true" size={12}>
            <TextField
              fullWidth
              required
              slotProps={{ inputLabel: { shrink: true } }}
              id="escritorio_uuid"
              name="escritorio_uuid"
              label="Escritório"
              value={formData.escritorio_uuid}
              select
              onChange={handleChangeEscritorio}
              disabled={!usuarioRoot}
            >
              {escritorios.map((option) => (
                <MenuItem key={option.escritorio_uuid} value={option.escritorio_uuid}>
                  {option.escritorio_nome}
                </MenuItem>
              ))}
            </TextField>
        </Grid>

          <Grid item="true" size={12}>
            <TextField
              fullWidth
              required
              slotProps={{ inputLabel: { shrink: true } }}
              id="documento_nome_cliente"
              name="documento_nome_cliente"
              label="Nome do Cliente"
              value={formData.documento_nome_cliente}
              onChange={handleChange}
            />
        </Grid>

        <Grid item="true" size={12}>
          <TextField
            fullWidth
            required
            slotProps={{ inputLabel: { shrink: true } }}
            id="genero_uuid"
            name="genero_uuid"
            select
            label="Gênero (para concordância do texto)"
            value={formData.genero_uuid}
            onChange={handleChange}
          >
            {generos.map((option) => (
              <MenuItem key={option.genero_uuid} value={option.genero_uuid}>
                {option.genero_nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item="true" size={10}>
          <TextField
            fullWidth
            required
            slotProps={{ inputLabel: { shrink: true } }}
            id="modelo_uuid"
            name="modelo_uuid"
            select
            label="Modelo do Documento"
            value={formData.modelo_uuid}
            onChange={handleChangeModelo}
          >
            {modelos.map((option) => (
              <MenuItem key={option.modelo_uuid} value={option.modelo_uuid}>
                {option.modelo_nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item="true" size={2} sx={{ textAlign: 'right' }}>
          <TextField
            fullWidth
            disabled
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { style: { textAlign: 'center' } },
            }}
            id="modelo_versao"
            label="Versão"
            value={formData.modelo_versao}
          />
        </Grid>

      </Grid>

      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button
          onClick={handleCloseDocumentoDialog}
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}>
          Voltar
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="large"
          color="success"
          startIcon={<NoteAddIcon />}>
          Cadastrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
